import './index.css';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { downArrowIcon } from '../../assets';


const CustomSelect = ({ value, icon, list, setValue, label }) => {

  const defaultList = list || [
    {
      key: 1,
      name: '1'
    },
    {
      key: 3,
      name: '3'
    },
    {
      key: 4,
      name: '4'
    },
    {
      key: 5,
      name: '5'
    }
  ]

  return <div className="custom-select">
    <select value={value} onChange={(e) => setValue(e.target.value)}>
      {defaultList.map((item) => (
        <option key={item.key} value={item.key}>{item.name}</option>
      ))}
    </select>
    <div className="custom-select-content">
      {(icon || label) && <div className="custom-select-content-left">
        {icon && <img src={icon} alt="icon" />}
        {label && <span className="custom-select-placeholder">{label}</span>}
      </div>}
      <div className="custom-select-content-right">
        <span className="custom-select-selected-value">{defaultList.find((item) => item.key === value)?.name}</span>
        <img src={downArrowIcon} alt="down-arrow" />
      </div>
    </div>
  </div>;
};

export default observer(CustomSelect);